import { render } from "./_menu.vue?vue&type=template&id=7ea80bab"
import script from "./_menu.vue?vue&type=script&lang=js"
export * from "./_menu.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/customers/_menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ea80bab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ea80bab', __exports__)) {
    console.log('reload')
    api.reload('7ea80bab', __exports__)
  }
  
  module.hot.accept("./_menu.vue?vue&type=template&id=7ea80bab", () => {
    console.log('re-render')
    api.rerender('7ea80bab', render)
  })

}


export default __exports__